import { CloseButton } from "@/components/CloseButton";
import { XMarkThin } from "@/icons";
import { getDataLinkAttributes } from "@/helpers";
import { BuilderBlockProps } from "@/types";
import { FC } from "react";

type CloseButtonBlockProps = { dld?: string; dlt?: string } & BuilderBlockProps;
export const CloseButtonBlock: FC<CloseButtonBlockProps> = ({
  attributes,
  dld,
  dlt,
}) => {
  return (
    <CloseButton
      data-autofocus
      {...attributes}
      {...getDataLinkAttributes({ dld, dlt })}
    >
      <XMarkThin aria-hidden className="size-6" />
    </CloseButton>
  );
};
